import { render, staticRenderFns } from "./HomeRedirect.vue?vue&type=template&id=0c15a0b8&"
import script from "./HomeRedirect.vue?vue&type=script&lang=ts&"
export * from "./HomeRedirect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports